import { notification } from 'antd';

export function openSuccessMsg(title, description) {
    notification.success({
        message: title,
        description,
        placement: "bottomright"
    });
}

export function openErrorMsg(title, description) {
    notification.error({
        message: title,
        description,
        placement: "bottomright"
    });
}

export function getLang() {
    const languageType = localStorage.getItem('languageType');
    let locale = 'zh_CN';
    if(languageType === 'en'){
        locale = 'en_US'
    }else if(languageType === 'ina'){
        locale = 'en_ID'
    }else if(languageType === 'ru_RU'){
        locale = 'ru_RU'
    }else if(languageType === 'es_ES'){
        locale = 'es_ES'
    }else if(languageType === 'fr_FR'){
        locale = 'fr_FR'
    }else if(languageType === 'th_TH'){
        locale = 'th_TH'
    }else if(languageType === 'ms_MS'){
        locale = 'ms_MS'
    }else if(languageType === 'pt_PT'){
        locale = 'pt_PT'
    }else if(languageType === 'vi_VI'){
        locale = 'vi_VI'
    }else if(languageType === 'ar_AR'){
        locale = 'ar_AR'
    }
    return locale;
}